import {
  Benefit,
  ClaimPropertiesResponse,
  ClinicOrDoctorSearchResponse,
  DiagnosisSearchResponse,
} from 'all-in-one-shared-api';
import { isLocaleEnglish } from 'utils/languageUtils';
import { ClaimTypesEnum } from '../../../claims/components/FilterSection/utils';

export class ClaimInfoCardUtils {
  static formatDoctorData(response: ClinicOrDoctorSearchResponse, lang: string) {
    return response?.results?.map((result) => ({
      ...result,
      name: isLocaleEnglish(lang) ? result.name : result.chineseName,
      caption: `${isLocaleEnglish(lang) ? result.chineseName : result.name} ${result.licenseNo ?? ''}`,
    }));
  }

  static formatDiagnosticData(response: DiagnosisSearchResponse, lang: string) {
    return response?.results?.map((result) => ({
      ...result,
      label: isLocaleEnglish(lang) ? result.description : result.chineseDescription,
    }));
  }

  static formatClaimTypeData(response: ClaimPropertiesResponse, lang: string) {
    return response.claimTypes?.map((result) => {
      let benefits: Benefit[] | undefined = [];

      if (result.benefits) {
        benefits = result.benefits.map((benefit) => ({
          ...benefit,
          description: isLocaleEnglish(lang) ? benefit.description : benefit.chineseDescription,
          requiredAttachments: isLocaleEnglish(lang) ? benefit.requiredAttachments : benefit.chineseRequiredAttachments,
        }));
      }

      return {
        ...result,
        benefits,
        description: isLocaleEnglish(lang) ? result.description : result.chineseDescription,
        requiredAttachments: isLocaleEnglish(lang) ? result.requiredAttachments : result.chineseRequiredAttachments,
      };
    });
  }
  static getTitleTreatmentBasedOnClaimType = (claimType = ClaimTypesEnum.OP) => {
    return claimType === ClaimTypesEnum.MAT || claimType === ClaimTypesEnum.HOSP
      ? 'newClaim.claimInfo.treatmentAdmissionDateLabel'
      : 'newClaim.claimInfo.treatmentDateLabel';
  };
}
